(function () {
  'use strict';

  /* @ngdoc object
   * @name trainingAllowanceReport
   * @description
   *
   */
  angular
    .module('trainingAllowanceReport', [
      'ui.router'
    ]);
}());
